import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Phone } from 'lucide-react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import SiteFooter from '../components/SiteFooter';
import Breadcrumbs from '../components/Breadcrumbs';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CancellationPolicy() {
  const [policy, setPolicy] = useState('');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/booking/config`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d) setPolicy(d.cancellation_policy || ''); })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const crumbs = [
    { name: 'Home', to: '/' },
    { name: 'Cancellation Policy', to: '/cancellation-policy' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Cancellation Policy | Restore.Dental Acton"
        description="Read Restore.Dental's booking and cancellation policy for appointments with Dr Kartik Patel in Acton, West London."
        path="/cancellation-policy"
        keywords={['cancellation policy dentist acton', 'restore dental booking policy']}
      />
      <PageHeader />
      <main className="pt-28 md:pt-32 pb-20">
        <section className="container mx-auto px-4 max-w-3xl">
          <Breadcrumbs items={crumbs} />
          <div className="flex items-center gap-3 mt-6 mb-6">
            <div className="w-11 h-11 rounded-xl bg-[#01A9B4]/10 flex items-center justify-center">
              <ShieldCheck className="w-6 h-6 text-[#006A71]" aria-hidden="true" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-bold text-rabbit" data-testid="cancellation-policy-h1">
              Cancellation Policy
            </h1>
          </div>
          <div
            className="whitespace-pre-line text-chocolate-malt leading-relaxed text-[15px] bg-sky-gray/5 border border-sky-gray/20 rounded-2xl p-6 md:p-8"
            data-testid="cancellation-policy-body"
          >
            {loaded ? (policy || 'Our cancellation policy will appear here shortly.') : 'Loading…'}
          </div>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/book"
              className="inline-flex items-center justify-center gap-2 bg-burnt-coral hover:bg-burnt-coral/90 text-white font-semibold px-6 py-3 rounded-full transition-colors"
              data-testid="cancellation-policy-book"
            >
              Book an appointment
            </Link>
            <a
              href="tel:+447787814064"
              className="inline-flex items-center justify-center gap-2 border border-sky-gray/30 text-rabbit px-6 py-3 rounded-full hover:bg-sky-gray/5 transition-colors"
            >
              <Phone className="w-4 h-4" /> 07787 814 064
            </a>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
